import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initTheme } from './lib/theme';
import './styles/globals.css';
import './styles/tokens.css';
import './styles/cards.css';
import './styles/ribbon.css';
import './styles/overview.css';
import './styles/browse.css';
import './styles/days.css';
import './styles/shell.css';
import './styles/map-phone.css';

initTheme();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
